import useUpdateUserSpecificCollectionItem from './useUpdateUserSpecificCollectionItem'

export default () => {
    return useUpdateUserSpecificCollectionItem('payees')
}
